// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { WidgetChartTypeEnum, WidgetLineOutput } from 'thehive-sdk';
import NewWidgetDrawer from '@Organisms/Dashboard/WidgetManage/NewWidgetDrawer';
import { LineForm, LineValues } from '@Organisms/Dashboard/WidgetManage/Line/LineForm';

export const getNewLineWidget = (line: LineValues): WidgetLineOutput => {
    const { title, interval, entity, dateField, series = [], filters, stacked, log } = line;

    return {
        type: WidgetChartTypeEnum.line,
        options: {
            title,
            entity,
            interval,
            dateField,
            query: {},
            series,
            filters,
            stacked,
            log,
        },
        id: '',
    };
};

const NewLineDrawer = (): ReactElement => (
    <NewWidgetDrawer
        getNewWidget={(values) => getNewLineWidget(values as LineValues)}
        WidgetForm={LineForm}
        widgetType="line"
    />
);

export default NewLineDrawer;
